const cloudAbilityRouter = {
  path: 'cloudfile-ability',
  name: '',
  component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
  meta: { title: '' },
  children: [
    {
      path: 'manage',
      redirect: 'manage/introduce',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      // component: () => import('@/apps/open/views/fileCenter/cloudfileAbility/manageCloudefile/index.vue'),
      meta: { title: '管理云文档文件', path: '/docs/cloud/cloudfile-ability/manage/access-know' },
      children: [
        {
          path: 'introduce',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '产品介绍', mdfilepath: '/cloudfileability/managecloudfile/Introduce.md', aimtilelist: ['产品介绍', '在线演示', '接入说明'] }
        },
        {
          path: 'quick-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '快速接入', mdfilepath: '/cloudfileability/managecloudfile/QuickAccess.md', aimtilelist: ['创建应用', '申请权限', '接口说明', 'Sdk&Demo接入'] }
        },
        {
          path: 'api-list',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api列表', mdfilepath: '/cloudfileability/managecloudfile/ApiList.md', aimtilelist: ['接口目录'] }
        },
        {
          path: 'java-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Java版接入', mdfilepath: '/cloudfileability/managecloudfile/JavaAccess.md', aimtilelist: ['接入须知', 'SDK下载', 'Demo试用', '应用开发'] }
        },
        {
          path: 'go-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Go版接入', mdfilepath: '/cloudfileability/managecloudfile/GoAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'python-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Python版接入', mdfilepath: '/cloudfileability/managecloudfile/PythonAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'php-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Php版接入', mdfilepath: '/cloudfileability/managecloudfile/PhpAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'js-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Js版接入', mdfilepath: '/cloudfileability/managecloudfile/JsAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        }
      ]
    },
    {
      path: 'obtain',
      redirect: 'obtain/file-select',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
      meta: { title: '获取云文档文件', path: '/docs/cloud/cloudfile-ability/obtain/file-select' },
      children: [
        {
          path: 'introduce',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '产品介绍', mdfilepath: '/cloudfileability/obtioncloudfile/Introduce.md', aimtilelist: ['产品介绍', '在线演示', '接入说明'] }
        },
        {
          path: 'quick-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '快速接入', mdfilepath: '/cloudfileability/obtioncloudfile/QuickAccess.md', aimtilelist: ['创建应用', '申请权限', '文件接入规范', '接口说明', 'Sdk&Demo接入'] }
        },
        {
          path: 'file-select',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: '文件选择器', mdfilepath: '/cloudfileability/obtioncloudfile/WpsFileSelect.md', aimtilelist: ['文件选择器参数', '文件列表获取'] }
        },
        {
          path: 'api-list',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Api列表', mdfilepath: '/cloudfileability/obtioncloudfile/ApiList.md', aimtilelist: ['接口目录'] }
        },
        {
          path: 'java-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Java版接入', mdfilepath: '/cloudfileability/obtioncloudfile/JavaAccess.md', aimtilelist: ['接入须知', 'SDK下载', 'Demo试用', '应用开发'] }
        },
        {
          path: 'go-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Go版接入', mdfilepath: '/cloudfileability/obtioncloudfile/GoAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'python-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Python版接入', mdfilepath: '/cloudfileability/obtioncloudfile/PythonAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'php-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Php版接入', mdfilepath: '/cloudfileability/obtioncloudfile/PhpAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        },
        {
          path: 'js-access',
          name: '',
          component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
          meta: { title: 'Js版接入', mdfilepath: '/cloudfileability/obtioncloudfile/JsAccess.md', aimtilelist: ['接入须知', 'SDK下载', '集成SDK开发'] }
        }
      ]
    }
  ]
}

export default cloudAbilityRouter
